// extracted by mini-css-extract-plugin
module.exports = {"footer-center":"createEventButton_footer-center__4IPCg","body-content":"createEventButton_body-content__zgQMe"};